import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=2f37253e&scoped=true&"
import script from "./TransactionList.vue?vue&type=script&lang=ts&"
export * from "./TransactionList.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=2f37253e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37253e",
  null
  
)

export default component.exports